jQuery( document ).ready(function() 
{
    const filter_checkboxes = '.filter-list-item input[type="checkbox"], .color-filter-item input[type="checkbox"]';
    $(filter_checkboxes).on('click', function () 
    {
        setTimeout(() => {
            wcUpdateURL();
        }, 250);
    });

    const sortingBtns = '.filter-list.fSortBy label button,.filter-list.fSortBy label a';
    $(sortingBtns).on('click', function () 
    {
        wcUpdateURL();
    });

    $(document).on('click','button.reset-all',function(e) 
    {
        wcUpdateURL();
    });
    

    function wcUpdateURL()
    {
        const url = new URL(window.location);
        const params = new URLSearchParams();

        const checkBoxfiltersGroup = 
        [
            { selector: '.percent-off', name: 'off', allowMultiple: true },
            { selector: '.fSizes', name: 'size', allowMultiple: true },
            { selector: '.color-filter-list', name: 'color' },
            { selector: '.fProductType', name: 'type', allowMultiple: true },
            { selector: '.fLengths', name: 'length' },
            { selector: '.fButtCoverage', name: 'coverage', allowMultiple: true },
            { selector: '.fDressLength', name: 'dress_length', allowMultiple: true },
            { selector: '.fCups', name: 'cup', allowMultiple: true },
            { selector: '.fProductSolution', name: 'solution', allowMultiple: true }
        ];

        checkBoxfiltersGroup.forEach(group => 
        {
            const group_selector = $(group.selector);
            const checkedValues = group_selector.find('input[type="checkbox"]:checked').map(function () 
            {
                return $(this).val().trim().toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-');
            }).get();
            if (checkedValues.length > 0) 
            {
                if (group.allowMultiple) 
                {
                    params.set(group.name, checkedValues.join(','));
                }
                else 
                {
                    params.set(group.name, checkedValues[checkedValues.length - 1]);
                }
            }
            else
            {
                params.delete(group.name);
            }
        });

        
        let SortByValue= '';
        $(sortingBtns).each(( index, ele )=> 
        {
            if($(ele).closest('.filter-list-item').hasClass('active-filter'))
            {
                SortByValue = $(ele).text().replace(/price/i,'').trim().replace(/\s+/g, '-').replace(/\//g, '-').toLowerCase();
            }
        });

        if(SortByValue)
        {
            console.log( ' SortByValue ',SortByValue );
            params.set('sort', SortByValue);
        }
        else
        {
            params.delete('sort');
        }
        
        let newUrl = `${url.origin}${url.pathname}`;
        if(params.size)
        {
            newUrl = `${newUrl}?${params.toString()}`;
        }
        history.pushState(null, '', newUrl);
        // /** Testing **/
        // params.forEach((value,key)=>{
        //     console.log(`${key}: ${value}`);
        // });
    }

function autoClickFromQueryString() 
    {
        const params = new URLSearchParams(window.location.search);
        if(params.size > 0)
        {
            const filtersGroup = 
                [
                    { selector: '.percent-off', name: 'off', type: 'checkbox' },
                    { selector: '.fSizes', name: 'size', type: 'checkbox' },
                    { selector: '.color-filter-list', name: 'color', type: 'checkbox' },
                    { selector: '.fProductType', name: 'type', type: 'checkbox' },
                    { selector: '.fLengths', name: 'length', type: 'checkbox' },
                    { selector: '.fButtCoverage', name: 'coverage', type: 'checkbox' },
                    { selector: '.fDressLength', name: 'dress_length', type: 'checkbox' },
                    { selector: '.fCups', name: 'cup', type: 'checkbox' },
                    { selector: '.fSortBy', name: 'sort', type: 'button' },
                    { selector: '.fProductSolution', name: 'solution', type: 'checkbox' }
                ];

            filtersGroup.forEach(group => 
            {   
                const param = params.get(group.name);
                if (param) 
                {
                    const values = param.split(',').map(v => v.trim().toLowerCase());
                    
                    values.forEach(val => 
                    {           
                        const group_selector = $(group.selector);
                        const isCheckbox = group.type === 'checkbox';

                        group_selector.find(isCheckbox ? 'input[type="checkbox"]' : 'button,a').each(function () 
                        {
                            
                            const ele = $(this);
                            const textVal = ele.text()?.replace(/price/i,'').trim().toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-');
                            const attrVal = ele.val()?.replace(/price/i,'').trim().toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-');



                            if (val === textVal || val === attrVal) 
                            {
                                
                                if(!$(ele).closest('.filter-list-container').hasClass('expanded') && window.innerWidth > 880)
                                {  
                                    if(group.name != 'length' )
                                    {
                                        $(ele).closest('.filter-list-container').find('.toggle-size').click();
                                    }
                                }

                                setTimeout(() => 
                                {
                                    if(isCheckbox)
                                    {
                                        if( !$(ele).is(':checked') ) 
                                        {
                                            if( group.name != 'length' || 1==1 )
                                            {
                                                ele.click();
                                            }
                                        }    
                                    }
                                    else
                                    {
                                        const el = $(ele)[0]; 
                                        if (typeof el === 'object') 
                                        {
                                            el.dispatchEvent(new MouseEvent('click', { bubbles: true }));
                                        }
                                    }
                                }, 250);

                                if(group.name == 'length' && window.innerWidth < 880)
                                {
                                    if (typeof wcShowSelectedLengthInMobile == 'function')     
                                    {
                                        setTimeout(() => {
                                            wcShowSelectedLengthInMobile();    
                                        }, 250);
                                    }
                                }
                            }
                        });
                        console.log(' ');
                    });
                }
                console.log('  ');
            });
            if(window.innerWidth < 880)
            {
                let counter = 1;
                const interval = setInterval(() => 
                {
                    counter++
                    const el = document.querySelector('.filter-list-container.expanded h3');
                    if (el || counter > 16) 
                    {
                        let delays = [100];
                        if(params.size < 3)
                        {
                            delays = [100,200];
                        }
                        else if(params.size < 5)
                        {
                            delays = [100,200,300];
                        }
                        else 
                        {
                            delays = [100,200,300,400];
                        }
                        delays.forEach((delay) => {
                            setTimeout(() => {
                                $('#lengths-filter.filter-list-container.expanded h3').click();
                            }, delay);
                        });

                        

                        if(params.size < 3)
                        {
                            setTimeout(() => {
                                $('body').addClass('auto-click-completed');    
                            }, 250);
                        }
                        else if(params.size < 5)
                        {
                            setTimeout(() => {
                                $('body').addClass('auto-click-completed');    
                            }, 450);
                        }
                        else
                        {
                            setTimeout(() => {
                                $('body').addClass('auto-click-completed');    
                            }, 550);
                        }
                        
                        
                        clearInterval(interval);
                    }
                }, 250);
            }
        }
        else
        {
            $('body').addClass('auto-click-completed');
        }
    }
    setTimeout(() => {
        autoClickFromQueryString();    
    }, 50);
    
    
    if (typeof wcShowSelectedLengthInMobile !== 'function') 
    {
        function wcShowSelectedLengthInMobile() 
        {
            if ($('.selected-length').is(':empty')) 
            {
                let checkedValues = [];
                $('.shopify-section .fLengths input[type="checkbox"]').each(function () 
                {
                    if ($(this).is(':checked')) 
                    {
                        checkedValues.push($(this).val());
                    }
                });
                $('.selected-length').empty();
                if (checkedValues.length > 0) 
                {
                    $(this).closest('.filter-list-container').find('.toggle-size').addClass('filter-applied');

                    $('.selected-filters .selected-length').show();
                    $('.selected-length').append('<span> length: </span>');
                    let icon =
                    '<svg class="icon--root icon--cross" viewBox="0 0 20 20"><path d="M10 8.727L17.944.783l1.273 1.273L11.273 10l7.944 7.944-1.273 1.273L10 11.273l-7.944 7.944-1.273-1.273L8.727 10 .783 2.056 2.056.783 10 8.727z" fill-rule="nonzero"></path></svg>';
                    for (let i = 0; i < checkedValues.length; i++) 
                    {
                        $('.selected-length').append(
                        '<a href="javascript:void(0)" class="selected-item">' + checkedValues[i] + icon + '</a>'
                        );
                    }
                } 
                else 
                {
                    $(this).closest('.filter-list-container').find('.toggle-size').removeClass('filter-applied');
                }
            }
        }
    }
});